import {
  AnalysisInput,
  IAnalysisForm,
  StepLabel,
  StepSummaryLabel,
  IStepper,
  IStepData,
  InputType,
  FormStep,
} from 'types';

export const stepperData: IStepper[] = [
  {
    id: 0,
    label: StepLabel.FILES,
    summaryLabel: StepSummaryLabel.UPLOADED,
  },
  {
    id: 1,
    label: StepLabel.VARIABLES,
    summaryLabel: StepSummaryLabel.SELECTED,
  },
  {
    id: 2,
    label: StepLabel.INDUSTRIES,
    summaryLabel: StepSummaryLabel.SELECTED,
  },
  {
    id: 3,
    label: StepLabel.COUNTRIES,
    summaryLabel: StepSummaryLabel.SELECTED,
  },
];

export const defaultValues: IAnalysisForm = {
  [AnalysisInput.FILES]: [],
  [AnalysisInput.INPUT]: '',
  [AnalysisInput.VARIABLES]: [],
  [AnalysisInput.INDUSTRIES]: [],
  [AnalysisInput.COUNTRIES]: [],
};

export const stepCardData: IStepData = {
  [FormStep.UPLOAD]: {
    title: 'upload files',
    description:
      'Upload PDF files you would like to analyse. You may drop them in the box below or select them from your hard drive.',
    input: {
      type: InputType.FILE,
      name: AnalysisInput.FILES,
    },
  },
  [FormStep.VARIABLES]: {
    title: 'add variables',
    description:
      'Type in the terms you would like to analyse in the uploaded documents.They may or may not be synonyms.Press ENTER after each.',
    input: {
      type: InputType.TEXT,
      placeholder: 'Type in the terms',
      name: AnalysisInput.VARIABLES,
    },
  },
  [FormStep.INDUSTRIES]: {
    title: 'add industries',
    description: 'Type in the industries you would like to be analysed. Press ENTER after each.',
    input: {
      type: InputType.TEXT,
      placeholder: 'Type in the industries',
      name: AnalysisInput.INDUSTRIES,
    },
  },
  [FormStep.COUNTRIES]: {
    title: 'add countries',
    description:
      'Type in the countries you would like to be the basis for analysis. Press ENTER after each.',
    input: {
      type: InputType.TEXT,
      placeholder: 'Type in the countries',
      name: AnalysisInput.COUNTRIES,
    },
  },
};

export const handleNextButtonData = (
  currentStep: number,
  dataLength: number,
  totalSteps: number
) => {
  switch (currentStep) {
    case 0:
      return {
        label: 'next step',
        disabled: !dataLength,
      };
    case 1:
      return {
        label: 'next step',
        disabled: !dataLength,
      };
    case 2:
      return {
        label: dataLength ? 'next step' : 'skip step',
      };
    case totalSteps:
      return {
        label: dataLength ? 'start analysis' : 'skip step and start analysis',
      };
    default:
      return {
        label: 'next step',
      };
  }
};
